define('view/module/cart/CartIconView',['require','lib/view/LayoutView','lib/Utils'],function (require) {

    var LayoutView = require('lib/view/LayoutView');
    var Utils = require('lib/Utils');

    return LayoutView.extend({

        template: '#cart_module_icon_view',

        ui: {
            'qty': '.sb-qty',
        },

        triggers: {
            'click': 'toggle:popup'
        },

        events: {
            // role="button" div doesn't fire click on Enter/Space natively — handle it (WCAG 2.1.1)
            'keydown': 'onKeydown'
        },
    
        modelEvents: {
            'sync': 'updateState',
            'change': 'updateState',
        },

        serializeData: function () {
            return _.extend(LayoutView.prototype.serializeData.call(this), {
                qty: this.model.getQty(),
            });
        },

        onKeydown: function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.keyCode === 13 || e.keyCode === 32) {
                e.preventDefault(); // prevent Space from scrolling the page
                this.trigger('toggle:popup');
            }
        },

        // update elements manually to prevent rerender of regions
        updateState: function () {
            this.ui.qty.text(this.model.getQty());
        }

    });

});
